import { render, staticRenderFns } from "./ListingDistributor.vue?vue&type=template&id=622d8dbc&scoped=true&"
import script from "./ListingDistributor.vue?vue&type=script&lang=js&"
export * from "./ListingDistributor.vue?vue&type=script&lang=js&"
import style0 from "./ListingDistributor.vue?vue&type=style&index=0&id=622d8dbc&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622d8dbc",
  null
  
)

export default component.exports